import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserProfile } from 'src/app/models/profile.model';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'update-userinfo-dialog',
  standalone: false,
  templateUrl: './update-userinfo-dialog.component.html',
  styleUrl: './update-userinfo-dialog.component.scss'
})
export class UpdateUserinfoDialogComponent implements OnInit {
  userInfo : UserProfile = this.data.userInfo;
  isSubscribed: boolean = this.data.isSubscribed;

  profileFormGroup : UntypedFormGroup;
  updating: boolean = false;

  constructor(    
    private readonly authService: AuthService,
    private readonly userService: UserService,
    private readonly materialSnackbar: MatSnackBar,
    private _formBuilder: UntypedFormBuilder,
    private readonly dialogRef: MatDialogRef<UpdateUserinfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public readonly data: {
      userInfo: UserProfile;
      isSubscribed: boolean;
    }
  ) {
    this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    if (this.userInfo != null) {
      this.setupForm();
    }
  }
    
  private setupForm(): void {
    this.profileFormGroup = this._formBuilder.group({
      firstname: [{ value: this.userInfo.firstName, disabled: true }, [Validators.maxLength(150)]],
      lastname: [{ value: this.userInfo.lastName, disabled: true }, [Validators.maxLength(150)]],
      email: [{ value: this.userInfo.email, disabled: true }],
      birthday: [{ value: this.userInfo.birthDay, disabled: false }],
    });
  }

  close(): void {
    //Reset to old values
    this.profileFormGroup.reset({
      firstname: this.userInfo.firstName,
      lastname: this.userInfo.lastName,
      email: this.userInfo.email,
      birthday: this.userInfo.birthDay
    });

    this.dialogRef.close();
  }

  async save(): Promise<void> {
    if(this.updating) return;
    if(!this.profileFormGroup.dirty && !this.profileFormGroup.valid) return;
    
    this.updating = true;

    var profile;
    if (this.isSubscribed) {
      profile = {
        firstname: this.profileFormGroup.get('firstname').value,
        lastname: this.profileFormGroup.get('lastname').value,
        birthday: this.profileFormGroup.get('birthday').value,
      };
    } else {
      profile = {
        birthday: this.profileFormGroup.get('birthday').value,
      };
    }

    try {
      await this.authService.updateProfile(JSON.stringify(profile));
    } catch (e)
    {
      console.error(e);
      this.close();
      return;
    }

    this.userInfo = {
      ...this.userInfo,
      firstName: profile.firstname || this.userInfo.firstName,
      lastName: profile.lastname || this.userInfo.lastName,
      birthDay: profile.birthday || this.userInfo.birthDay,
    };

    // Update local observable
    this.userService.updateUserInfo(this.userInfo);

    this.profileFormGroup.get('firstname').disable();
    this.profileFormGroup.get('lastname').disable();
    this.profileFormGroup.get('birthday').disable();

    this.updating = false;
    this.dialogRef.close();

    this.materialSnackbar.open(
      `U wijzingen zijn opgeslagen!`,
      'Ok',
      {
        duration: 5000,
        panelClass: "snackbar-successful",
      }
    );

    this.authService.loginSilent().then(() => {
        // nothing to do
      }).catch((error : any) => {
        console.log(error)
      });
  }
}
